<script>
    import Util from "../lib/util.js";
    import Actions from "../lib/actions.js";
    import { logout } from "../Auth.svelte";

    import IconButton from '@smui/icon-button';
    import Checkbox from '@smui/checkbox';
    import FormField from '@smui/form-field';

    import Drawer, {AppContent, Content, Header, Title, Subtitle, Scrim} from '@smui/drawer';
    import Button, {Label} from '@smui/button';
    import List, {Item, Text, Graphic, Separator, Subheader} from '@smui/list';
    import Icon from 'svelte-awesome';
    import { cog, pieChart, diamond, image } from 'svelte-awesome/icons';
    import { faPeopleCarry, faTachometerAlt } from '@fortawesome/free-solid-svg-icons';
    import { link } from "svelte-routing";
    import { navigate } from "svelte-routing";

    import NewProjectButton from "./NewProjectButton.svelte";
    import Background from "./Background.svelte";
    import ComingSoonSticker from "./ComingSoonSticker.svelte";

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    const backgrounds = [
        // trees on bottom, sky on top
        "photo-1418065460487-3e41a6c84dc5",
        // water on bottom, island on top
        "photo-1497436072909-60f360e1d4b1",
        // vertical road to hill
        "photo-1510797215324-95aa89f43c33",
        // very cool high trees
        "photo-1420745981456-b95fe23f5753"
    ];

    // instance of the main dashboard menu
    let drawer;

    let backgroundImgUrl = Util.unsplashIdToSrc(backgrounds[0]);

    // allow instantiating the dasboard with a drawer config
    export let opened = true;
    let backgroundLoaded = true;

    // dashboard page that is active
    export let active = 'Overview';

    export let iconScale = 2;

    export let isAdmin = false;

    function handleNewProjectButtonClick() {
        dispatch("newProjectPlease");
    }

    function handleSwitchBackground() {
        dispatch("newBackgroundPlease");
    }

    function setActive(value) {
        active = value;
        opened = true;
    }
</script>

<Drawer id="dashboard-drawer" variant="dismissible" bind:this={drawer} bind:open={opened}>
<!--    <Background-->
<!--            quality={80}-->
<!--            height={900}-->
<!--            content="random"-->
<!--            images={backgrounds}-->
<!--            parallax={false}-->
<!--            on:loaded={() => backgroundLoaded = true} />-->

    <Background
            content="#212233"
            on:loaded={() => backgroundLoaded = true} />

    <div class="drawer-inner" class:backgroundLoaded style="position:relative;">
        <Header id="drawer-header" style="margin-bottom: 25px;">
            <Title>
                <a href="/">
<!--                    <img id="logo-symbol" src="/logo/evalueaid-symbol.png" alt="Evalueaid logo">-->
                    <img id="logo" src="/logo/evalueaid.contrast.png" alt="Evalueaid logo">
                </a>
            </Title>
<!--            <Subtitle style="text-align: center;">Worthy solutions</Subtitle>-->
        </Header>
        <Content style="display: flex; flex-direction: column;">
            <List style="display: flex; flex-direction: column; flex: 1;">
                <NewProjectButton
                        on:click={handleNewProjectButtonClick}
                        id="dashboard-new-project-button"
                        style="margin-bottom: 50px;"/>

                <Separator/>

<!--                <Item-->
<!--                    href="javascript:void(0)"-->
<!--                    on:click={() => setActive('Overview')} activated={active === 'Overview'}>-->
<!--                        <Icon scale={iconScale} data={faTachometerAlt}/>-->
<!--                        <Text>Overview</Text>-->
<!--                </Item>-->
<!--                <Item-->
<!--                    href="javascript:void(0)"-->
<!--                    on:click={() => setActive('ValueAid')} activated={active === 'ValueAid'}-->
<!--                    disabled>-->
<!--                        <Icon scale={iconScale} data={diamond}/>-->
<!--                        <Text>ValueAid</Text>-->
<!--                        <ComingSoonSticker short/>-->
<!--                </Item>-->
<!--                <Item-->
<!--                    href="javascript:void(0)"-->
<!--                    on:click={() => setActive('ParticipAid')} activated={active === 'ParticipAid'}>-->
<!--                        <Icon scale={iconScale} data={pieChart}/>-->
<!--                        <Text>ParticipAid</Text>-->
<!--                </Item>-->
<!--                <Item-->
<!--                    href="javascript:void(0)"-->
<!--                    on:click={() => setActive('TeamAid')} activated={active === 'TeamAid'}-->
<!--                    disabled>-->
<!--                        <Icon scale={iconScale} data={faPeopleCarry}/>-->
<!--                        <Text>TeamAid</Text>-->
<!--                        <ComingSoonSticker short/>-->
<!--                </Item>-->

    <!--            <Separator style="flex: 1"/>-->
                <!-- TODO: replace with native element from library -->
                <Item disabled style=""/>

<!--                <Item-->
<!--                    href="javascript:void(0)"-->
<!--                    on:click={() => setActive('Settings')} activated={active === 'Settings'}>-->
<!--                        <Icon scale={iconScale} data={cog}/>-->
<!--                        <Text>Settings</Text>-->
<!--                </Item>-->

                {#if isAdmin}
                    <Item href="/admin" on:click={() => navigate("/admin")}>
                        <Icon scale={iconScale} data={cog}/>
                        <Text>Admin</Text>
                    </Item>
                {/if}

                <Item
                        href="javascript:void(0)"
                        on:click={Actions.logout}>

                    <Text>Logout</Text>
                </Item>
            </List>
        </Content>
    </div>

    <span class="background-switcher" on:click={handleSwitchBackground}>
        <Icon scale={1} data={image} class="background-switcher"/>
    </span>
</Drawer>

<style>

    #logo, #logo-symbol {
        max-width: 100%;
        display: block;
        margin: auto;
    }

    #logo-symbol {
        max-width: 64px;
    }

    :global(.background-switcher) {
        position: absolute;
        bottom: 10px;
        right: 7px;
    }

    :global(#dashboard-drawer) {
        background: #fbfbfb;
        background: transparent;
        position: relative;
        //margin-right: 25px;
        padding: 50px 25px;
        background-size: cover;
        background-position: center center;
        padding-top: 0;
    }

    /* make logo white instead of black */
    :global(#drawer-header #logo), :global(#drawer-header h2) {
        //filter: invert(1);
    }

    :global(#dashboard-drawer .drawer-inner) {
        transition-delay: 1s;
        transition-duration: 0.7s;
        transition-property: opacity;
        opacity: 0;
    }
    
    :global(#dashboard-drawer .drawer-inner.backgroundLoaded) {
        opacity: 1;
    }

    :global(#dashboard-drawer .mdc-drawer__content .mdc-list-item) {
        justify-content: right;
        color: white;
        font-weight: bold;
        font-size: 16px;
        //background-color: rgba(0, 0, 0, 0.2);
        text-shadow: 1px 1px 3px #3339;
        flex-direction: row-reverse;
    }

    :global(#dashboard-drawer .mdc-drawer__content .mdc-list-item__text) {
        overflow: show;
    }

    :global(#dashboard-drawer .fa-icon) {
        margin: 0 5px;
        color: #DDD;
        height: 20px;
    }

</style>